export { default } from './ScheduleAssign.js';